import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from './localization.js';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


class InputModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bookmarkName: ''
        };

        this.close = this.close.bind(this);
        this.handlePositiveClick = this.handlePositiveClick.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }


    close() {
        this.props.handleClose();
    }

    handlePositiveClick() {
        if (this.state.bookmarkName !== undefined && this.state.bookmarkName !== '') {
            this.close();
            this.props.handleYes(this.state.bookmarkName);
            this.setState({ bookmarkName: '' });
        }
    }

    onInputChange(evt) {
        this.setState({ bookmarkName: evt.target.value });
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.close}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    {'Add Bookmark'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {LocalizedStrings.saveBookmarkExplanation}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Name"
                        type="text"
                        fullWidth
                        value={this.state.bookmarkName}
                        onChange={this.onInputChange}
                    />
                    <DialogContentText>
                        {LocalizedStrings.saveBookmarkNote}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.close} color="primary">
                        {LocalizedStrings.cancel}
                    </Button>
                    <Button onClick={this.handlePositiveClick} color="primary">
                        {LocalizedStrings.confirm}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
};

InputModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleYes: PropTypes.func.isRequired
};

export default InputModal;